import axios from 'axios';

export const GET_CHAT_NOTIFICATION_LIST = '[CHAT APP] GET CHAT NOTIFICATION LIST';

export function getChatNotificationList() {
	return (dispatch, getState) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user && current_user['authToken'];

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/profile/get-chat-notification-list', {
			headers: { Authorization: `Token ${token}` },
		});

		return request.then(response => {
			return dispatch({
				type: GET_CHAT_NOTIFICATION_LIST,
				data: response.data.notifications
			});
		});
	};
}
